module.exports = __webpack_public_path__ + "img/download.f2c60773.svg";